import React, { useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import BarChart from 'components/BarChart'
import { IReportFilter } from 'views/Reports'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import { AccentArea } from 'components'

/**
 * @name ByPlatform
 * @desc Render % of Chargebacks by Platform (Top 5) chart
 * @filterValues IReportsFilter
 */
const ByPlatform = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const { clientTheme } = useThemeStyling()
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<{ name: string; value: number }[]>([])
    const [customDomain, setCustomDomain] = useState<[number, number] | undefined>(undefined)

    React.useEffect(() => {
        setLoading(true)
        ReportsApi.getByPlatform(filterValues).then((data) => {
            setLoading(false)
            // removes the 'Others' data object from the chart data
            const top5Issuers = data.filter((bin: any) => bin.name !== 'Others')

            // Calculate custom domain based on data values
            if (top5Issuers.length > 0) {
                const values = top5Issuers.map((item: any) => item.value)
                const maxValue = Math.max(...values)
                // Set upper bound to be 20% higher than the max value to provide some space
                // and ensure a minimum upper bound of 5% for very small values
                const upperBound = Math.max(maxValue * 1.2, 5)
                setCustomDomain([0, upperBound])
            }

            setData(top5Issuers)
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AccentArea title="% of Chargebacks by Platform (Top 5)">
            <BarChart
                data={data}
                loading={loading}
                valueDataKey="value"
                barLineColor={clientTheme.charts.barCharts.byPlatformBarChart.fill}
                dataValuePercent
                showLegend={false}
                tooltipPercent
                disableAutoDomain={true}
                customDomain={customDomain}
                //Remove if no showLegend
                // height={280}
            />
        </AccentArea>
    )
}

export default ByPlatform
